export function transform(data) {
    console.log("transforming data", data);
    
    if(!data) {
        return data;
    }
    if(!Array.isArray(data.details)) {
        return data;
    }
    
    //add a sequential id to each detail item and convert the lastUpdated date to a Date object
    data.details.forEach((item, index) => {
        item.id = index + 1;
        item.lastUpdated = new Date(item.lastUpdated);
    });    


    return data;
}